import { BUTTON_LABELS } from "@miplatform/constants";
import { IRoleListItemResponse } from "@miplatform/types";
import { mdiContentCopy, mdiPencilOutline, mdiTrashCanOutline } from "@mdi/js";
import { useTheme } from "@mui/material";
import { ConfigCard } from "../ConfigCard/ConfigCard";

export const ConfigRoleCard = ({
  item: role,
  navigateToRoleDetails = () => {},
  onClick = () => {},
  handleDeleteRole,
  handleDuplicateRole,
  canUpdateRole = false,
  canDeleteRole = false,
  canCreateRole = false,
}: ConfigRoleCardProps) => {
  const { modifiedOn, name, id, usersCount, createdOn } = role;
  const theme = useTheme();

  const roleActions = [];

  if (canUpdateRole) {
    roleActions.push({
      label: BUTTON_LABELS.EDIT,
      action: () => {
        navigateToRoleDetails(id);
      },
      icon: mdiPencilOutline,
    });
  }

  if (canCreateRole) {
    roleActions.push({
      label: BUTTON_LABELS.DUPLICATE,
      action: () => {
        if (handleDuplicateRole) {
          handleDuplicateRole(role);
        }
      },
      icon: mdiContentCopy,
    });
  }

  if (usersCount === 0 && canDeleteRole) {
    roleActions.push({
      label: BUTTON_LABELS.DELETE,
      action: () => {
        handleDeleteRole(role);
      },
      icon: mdiTrashCanOutline,
      color: theme.palette.red.main,
    });
  }

  return (
    <ConfigCard
      title={name}
      additionalTitleText={[`${usersCount} users`]}
      modifiedOn={modifiedOn}
      menuActions={roleActions}
      createdOn={createdOn}
      onClick={() => onClick(id)}
    />
  );
};

interface ConfigRoleCardProps {
  item: IRoleListItemResponse;
  navigateToRoleDetails: (roleId: string) => void;
  onClick?: (roleId: string) => void;
  canUpdateRole?: boolean;
  canDeleteRole?: boolean;
  canCreateRole?: boolean;
  handleDeleteRole: (role: IRoleListItemResponse) => void;
  handleDuplicateRole?: (roleData: IRoleListItemResponse) => void;
}
